import Board from "./Board"
import BoardColumnChooser from "./BoardColumnChooser"
import Typography from "@material-ui/core/Typography"

import { makeStyles, Theme } from "@material-ui/core"
import { useIsSmallScreen } from "../../hooks/use-is-small-screen"
import { useTranslation } from "react-i18next"
import { BoardViewModelV2 } from "../api/v2/board-view-model"

type BoardViewProps = {
  title: string
  board: BoardViewModelV2
  canAddTasks: boolean
  canAddTodos: boolean
}

const BoardViewHeader = ({ title, board }: Pick<BoardViewProps, "title" | "board">) => {
  const classes = useStyles()
  const translations = useTranslations()
  const isSmallScreen = useIsSmallScreen()

  if (isSmallScreen) return null

  return (
    <div className={classes.header}>
      <h6 style={{ margin: 0 }}>
        <Typography variant="h4" color="textSecondary" component="span">
          {title}
        </Typography>
        <Typography variant="h4" component="span" style={{ marginLeft: 4, marginRight: 4 }}>
          -
        </Typography>
        <Typography variant="h4" component="span">
          {translations.pageTitle}
        </Typography>
      </h6>
      <BoardColumnChooser boardId={board.id} boardType={board.type} />
    </div>
  )
}

const BoardView = ({ title, board, ...boardProps }: BoardViewProps) => {
  return (
    <>
      <BoardViewHeader title={title} board={board} />
      <Board board={board} {...boardProps} />
    </>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  header: {
    margin: theme.spacing(0.75, 0),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}))

const useTranslations = () => {
  const { t } = useTranslation()
  return {
    pageTitle: t("boardView.pageTitle"),
  }
}

export default BoardView
